export default "__VITE_ASSET__CnvUqk_D__"